import * as actionTypes from "./actionTypes";

export const constructSearchURL = (name, value) => {
  return {
    type: actionTypes.ADD_SEARCH_PARAM,
    paramName: name,
    paramValue: value,
  };
};
export const resetSearchParam = () => {
  return {
    type: actionTypes.RESET_SEARCH_PARAM,
  };
};
